export default __webpack_public_path__ + "static/media/LogoNovaLight.dd02af6c.svg";